export enum SanityButtonActions {
  openGelatoPlusModal = 'open-gelato-plus-modal',
  activateDiscount = 'activate-discount',
}
